export default "__VITE_PUBLIC_ASSET__9a3a5161__"